<script setup lang="ts">
import { ref } from 'vue';
import { IonContent, IonButton, IonIcon } from '@ionic/vue';
import { chevronBackOutline, closeOutline } from 'ionicons/icons';

import ModalOne from '@/shared/components/ui/ModalOne.vue';
import TopBar from '@/shared/components/TopBar.vue';
import useModal from '@/shared/composables/useModal';
import SignUpWithPhoneForm from '../components/SignUpWithPhoneForm.vue';

// Init
const { isModalOpen, showHideModal, modalTitle, modalContent } = useModal();

const isFormValid = ref(false);
const onFormValidation = (formValid: boolean) => {
	isFormValid.value = formValid;
};
</script>

<template>
	<ion-content>
		<ModalOne :title="modalTitle" :is-open="isModalOpen">
			<template #content>
				<div class="font-sourcesanspro-regular text-sm text-center text-white/50 leading-[18px]">
					{{ modalContent }}
				</div>
			</template>

			<template #actions>
				<div class="flex items-center justify-center">
					<div class="flex items-center justify-center w-[60px] h-[60px] rounded-full bg-white">
						<ion-icon class="text-[38px] text-black cursor-pointer" :icon="closeOutline" @click="showHideModal(false)"></ion-icon>
					</div>
				</div>
			</template>
		</ModalOne>

		<div class="flex flex-col justify-between h-full">
			<div>
				<TopBar class="flex px-[34px]">
					<template #left>
						<div class="flex items-center justify-start cursor-pointer">
							<ion-button class="w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full" shape="round">
								<router-link to="/auth/signuphome" class="flex items-center justify-center">
									<ion-icon :icon="chevronBackOutline" class="ion-no-padding ion-no-margin text-black mr-[2px]"></ion-icon>
								</router-link>
							</ion-button>
						</div>
					</template>
				</TopBar>

				<div class="px-[34px] pt-6">
					<SignUpWithPhoneForm @on-form-validation="onFormValidation" />
				</div>
			</div>

			<div class="w-full">
				<div class="flex justify-center next-button w-full mb-4 padding-app-left padding-app-right">
					<ion-button class="w-full" color="primary" :disabled="!isFormValid" expand="full" form="signUpWithPhoneForm" shape="round" size="large" type="submit">
						{{ $t('auth.sign_up_phone_page.button') }}
					</ion-button>
				</div>
			</div>
		</div>
	</ion-content>
</template>

<style lang="scss" scoped></style>
